
































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import Pagination from "@/components/pagination/Pagination.vue";
import { Table as ElTable } from "element-ui";
import Sortable from "sortablejs"; // 用于拖拽排序
import { IPanelData } from "@/data/commonModel";
import {
  IPackageModel,
  IPackageListQuery,
  IPackageSortReqModel,
} from "../data/packageModel";
import { PackageModule } from "@/store/modules/package";
import {
  getPackageRecords,
  updatePackagePublishStatus,
  deletePackage,
  updatePackageListSort,
  getPackageDetails,
} from "@/remote/package";
import { getWineryInfo } from "@/remote/common";
import { addClass, removeClass } from "@/utils/tools";

@Component({
  components: {
    Pagination,
  },
})
export default class extends Vue {
  @Prop({
    required: true,
  })
  panelObj!: IPanelData;
  // 开始/取消前端显示排序
  @Prop({ default: false })
  isOrdering!: boolean;

  columnLableWidth: string = "110px";
  smallColumnLableWidth: string = "100px";
  titleColumnLableWidth: string = "180px";

  listLoading: boolean = false;
  list: IPackageModel[] = [];
  totalSize = 0;
  listQuery: IPackageListQuery = {
    type: "all",
  };
  sortable: any = null;
  maxPackageIntroductions: number = 6;

  @Watch("panelObj", {
    deep: true,
    immediate: true,
  })
  _onPanelObjChange(value: IPanelData) {
    this.listQuery.type = value.type;
    this.listQuery.titleOrSubTitle = value.searchText;
    this._fetchPackageRecords({
      ...this.listQuery,
    });
  }

  @Watch("isOrdering", {
    immediate: true,
  })
  onIsOrderingChange(value: boolean) {
    if (this.sortable) {
      this.sortable.option("disabled", !value);
    }
    if (value && this.listQuery.updatedTime !== "") {
      // console.log("清除创建、发布时间排序");
      // 清除创建、发布时间排序
      this.listQuery.updatedTime = "";
      const table = this.$refs["package-table"] as ElTable;
      table.clearSort();
      this.refreshTable();
    } else if (this.sortable && !value) {
      // 保存排序
      this._updateTableSort();
    }
  }

  mounted() {
    this._rowDrop();
    this._getMaxPackageIntroductions();
  }

  public refreshTable() {
    this._fetchPackageRecords({
      ...this.listQuery,
    });
  }

  async _getMaxPackageIntroductions() {
    try {
      const res = await getWineryInfo();
      if (res && res.data && res.data.data) {
        const { maxPackageIntroductions } = res.data.data;
        this.maxPackageIntroductions = maxPackageIntroductions;
      }
    } catch {
      // console.log("_getMaxPackageIntroductions 出错了");
    }
  }

  async _fetchPackageRecords(params: IPackageListQuery) {
    this.listLoading = true;
    try {
      const res = await getPackageRecords(params);
      if (res && res.data && res.data.data) {
        const { data } = res.data;
        data.forEach((element: IPackageModel) => {
          element.updatedAtText = moment(element.updatedAt).format(
            "YYYY-MM-DD"
          );
          // if (
          //   (element.type === 0 || element.type === 2) &&
          //   element.imageCoverImage
          // ) {
          //   element.coverImagePath = element.imageCoverImage.path;
          // } else if (element.type === 1 && element.videoCoverImage) {
          //   element.coverImagePath = element.videoCoverImage.path;
          // }
          element.titleForList =
            element.title.length === 0 ? "无" : element.title;
          element.subTitleForList =
            element.subtitle.length === 0 ? "无" : element.subtitle;
          // element.typeDes =
          //   element.type === 0
          //     ? "图片"
          //     : element.type === 2
          //     ? "小程序"
          //     : "视频影音";
        });
        this.list = data;
      } else {
        this.list = [];
      }
    } catch (error) {
      // console.log(error);
      // console.log("getPackageRecords 出错了");
    }
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  _onSortChange(column: any) {
    const { order, prop } = column;
    if (!order) {
      this.listQuery.updatedTime = "";
    } else if (order === "descending") {
      this.listQuery.updatedTime = "DESC";
    } else {
      this.listQuery.updatedTime = "ASC";
    }
    this.refreshTable();
  }

  async _onClickEdit(id: string) {
    this.listLoading = true;
    try {
      const res = await getPackageDetails(id);
      if (res && res.data && res.data.data) {
        this.$emit("onEditPackage", res.data.data);
      } else {
        this.$message.error("获取套餐详情失败");
      }
      this.listLoading = false;
    } catch {
      this.listLoading = false;
      // console.log("getPackageDetails 失败了");
    }
  }

  _onChangeSwitch(value: boolean, id: string, index: number) {
    if (
      PackageModule.PackageCountRes.publishedCount >=
        this.maxPackageIntroductions &&
      value
    ) {
      this.list[index].isPublished = false;
      this.$message.error("已发布套餐已达上限");
      return;
    }
    if (PackageModule.PackageCountRes.publishedCount === 1 && !value) {
      this.list[index].isPublished = true;
      this.$message.error("套餐无法为空。");
      return;
    }
    this.$confirm("", value ? "确认发布这个套餐吗？" : "确认取消发布吗？", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      center: true,
    })
      .then(() => {
        this._onUpdatePublishStatus(value, id, index);
      })
      .catch(() => {
        this.list[index].isPublished = !value;
      });
  }

  async _onUpdatePublishStatus(value: boolean, id: string, index: number) {
    try {
      this.listLoading = true;
      const res = await updatePackagePublishStatus(id, value);
      this.listLoading = false;
      if (res.data.resultCode === 0) {
        if (this.listQuery.type === "all") {
          this.list[index].isPublished = value;
        } else {
          this.refreshTable();
        }
        this.$message.success("操作成功");
        PackageModule.FetchPackageCountByStatus();
      }
    } catch {
      this.listLoading = false;
    }
  }

  // 删除
  _onClickDelete(id: string) {
    this.$confirm("", "确认删除这个套餐吗？", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      center: true,
    })
      .then(() => {
        this._deletePackage(id);
      })
      .catch(() => {});
  }

  async _deletePackage(id: string) {
    try {
      this.listLoading = true;
      const res = await deletePackage(id);
      this.listLoading = false;
      if (res && res.status === 200) {
        this._fetchPackageRecords(this.listQuery);
        this.$message.success("操作成功");
        PackageModule.FetchPackageCountByStatus();
      }
    } catch {
      this.listLoading = false;
    }
  }

  //行拖拽
  _rowDrop() {
    const tbody = document.querySelector(".el-table__body-wrapper tbody");
    const _this = this;
    // console.log("tbody", tbody);
    if (!tbody) return;
    this.sortable = new Sortable(tbody, {
      disabled: true,
      onStart: () => {
        addClass(".el-table__body-wrapper tbody", "cursor-move");
        removeClass(".el-table__body-wrapper tbody", "cursor-default");
      },
      onEnd: (event: any) => {
        const { newIndex, oldIndex } = event;
        const currRow = _this.list.splice(oldIndex, 1)[0]; // 删除
        _this.list.splice(newIndex, 0, currRow); // 添加到指定位置
        removeClass(".el-table__body-wrapper tbody", "cursor-move");
        addClass(".el-table__body-wrapper tbody", "cursor-default");
      },
    });
  }

  // 更新展示排序
  async _updateTableSort() {
    const arr: IPackageSortReqModel[] = [];
    this.list.forEach((element: IPackageModel, index: number) => {
      arr.push({ id: element.id, order: index + 1 });
    });
    try {
      this.listLoading = true;
      const res = await updatePackageListSort(arr);
      if (res && res.status === 200) {
        this.$message.success("保存成功");
      } else {
        this.$message.error("保存失败，请重试");
      }
      this.listLoading = false;
    } catch {
      this.listLoading = false;
      this.$message.error("保存失败，请重试");
      // console.log("updatePackageListSort 出错了");
    }
  }
}
